
import loadJsonFromText from './loadJsonFromText';
import loadJsonFromUrl from './loadJsonFromUrl';
import loadScripts from './loadScripts';
import loadTextFromUrl from './loadTextFromUrl';
import processValueWithValues from './processValueWithValues';
import styles from './styles';
import { fromWgs84, toWgs84 } from './proj4utils';

export default {
    loadJsonFromText,
    loadJsonFromUrl,
    loadScripts,
    loadTextFromUrl,
    processValueWithValues,
    styles,
    fromWgs84,
    toWgs84
};
